function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#B4B4B4",
  points: "20.642,4.477 48.606,0.228 49.497,2.467 91.783,6.936 103.188,35.906 110.012,41.167  110.351,48.992 113.479,47.883 120.303,54.59 124.327,64.879 126.457,77.185 125.334,85.794 130.704,99.774 134.397,102.242  134.956,113.088 140.213,119.014 143.123,126.513 140.442,139.71 143.683,148.997 152.066,150.114 155.316,145.083 160.348,151.457  163.48,152.353 164.486,157.608 168.51,157.608 171.646,167.116 170.41,170.692 178.802,177.409 179.358,185.457 175.334,192.394  161.576,200 156.878,193.85 149.717,172.036 142.896,170.137 125.898,147.877 111.578,142.844 105.764,136.129 106.097,131.097  97.6,128.3 101.067,102.794 102.854,101.677 99.722,78.525 92.562,69.352 90.436,70.249 81.713,64.318 74.889,47.883 57.887,47.654  54.197,39.824 47.036,37.92 43.346,30.317 34.848,28.081 34.397,18.686 28.247,15.543 26.458,8.058 22.428,9.172 "
});

var Svg03 = function Svg03(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "BCS",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    enableBackground: "new 0 0 200 200",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg03, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/03.a47dc46e.svg";
export { ForwardRef as ReactComponent };